import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-localAssociations',
  templateUrl: './localAssociations.component.html',
  styleUrls: ['./localAssociations.component.scss']
})
export class LocalAssociationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
